// import axios from 'axios';

// const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL + '/api/v1';

// // Instancia general para consultas bajo /api
// export const api = axios.create({
//   baseURL: `${API_BASE_URL}`,
//   headers: { 'Content-Type': 'application/json' },
//   withCredentials: false, // ✅ Cambiado a false - sin cookies
// });

// // Interceptor para agregar token automáticamente
// api.interceptors.request.use(
//   (config) => {
//     if (typeof window !== 'undefined') {
//       const token = localStorage.getItem('access_token');
//       if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//       }
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Manejo de errores
// const handleError = (error: unknown) => {
//   // Manejar error 401
//   if ((error as any).response?.status === 401) {
//     if (typeof window !== 'undefined') {
//       localStorage.removeItem('access_token');
//       localStorage.removeItem('user');
//       window.location.href = '/login';
//     }
//   }
  
//   console.error('API Error:', (error as any).response?.data || (error as any).message);
//   return Promise.reject(error);
// };

// api.interceptors.response.use(response => response, handleError);






import axios from 'axios';

export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL + '/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Interceptor para manejar errores 401 (token expirado)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // ⭐ CRÍTICO: Evitar bucle infinito
    // NO intentar refresh si:
    // 1. Ya se intentó antes (_retry)
    // 2. Es una ruta de auth
    // 3. Es el endpoint /me (checkAuth)
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url?.includes('/auth/login') &&
      !originalRequest.url?.includes('/auth/refresh') &&
      !originalRequest.url?.includes('/auth/me') &&  // ⭐ NUEVO
      !originalRequest.url?.includes('/auth/register')
    ) {
      originalRequest._retry = true;

      try {
        // Intentar refrescar el token
        await api.post('/auth/refresh');
        
        // Reintentar la petición original
        return api(originalRequest);
      } catch (refreshError) {
        // Si falla el refresh, NO redirigir aquí
        // Dejar que el AuthContext maneje el estado
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);